import { NgModule } from '@angular/core';

import { MetaGuard } from './guards';
import { MetaService } from './services';

@NgModule({
    providers: [
        MetaGuard,
        MetaService,
    ],
})

export class MetaModule {}
